<div class="card-body">
  <div class="card-body">
    <div class="row">
      <div class="col-12 text-right">
        <h5>
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: end;
              align-items: center;
              gap: 5px;
            "
          >
            <i class="bi fa-xl text-gray-500" [class]="icon"></i>
            <span *ngIf="!isLoading">{{ value }}</span>
            <p-skeleton width="2em" *ngIf="isLoading" />
          </div>
        </h5>
      </div>
    </div>
    <div *ngIf="isLoading">
      <p-skeleton height="435px" />
    </div>
    <div *ngIf="!isLoading">
      <div *ngFor="let ranking of rankings; let i = index">
        <h4 class="small font-weight-bold">
          {{ ranking.label }}
          <span class="float-right">{{ ranking.value }}</span>
        </h4>
        <div class="progress mb-4">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width]="ranking.percentage + '%'"
            aria-valuenow="20"
            aria-valuemin="0"
            aria-valuemax="100"
            [style.backgroundColor]="colors[i]"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
